import {
  differenceInMinutes,
  differenceInSeconds,
  format,
  isBefore,
  isSameDay,
  isSameMonth,
  isSameYear,
  parseISO,
  startOfDay,
} from 'date-fns'

export const formatDate = (date: string | undefined, dateFormat?: string) => {
  if (!date) {
    return
  }

  try {
    // check if date comes in ISO_8601 standard and reverse if not
    const isISOformat = Number(date.split('-')[0]) >= 1000
    const dateStringToUse = isISOformat
      ? date
      : date.split('-').reverse().join('-')
    const parsedDate = parseISO(dateStringToUse.toString())

    if (isNaN(parsedDate.getTime())) {
      return ''
    }

    return format(parsedDate, dateFormat || 'd MMM yyyy')
  } catch {
    return ''
  }
}

export const formatIsoDate = (
  isoDate: string | undefined
): string | undefined => {
  return isoDate ? format(parseISO(isoDate), 'yyyy-MM-dd') : undefined
}

export const formatPastDate = (dateInput: string | undefined): string => {
  if (!dateInput) {
    return ''
  }

  const date = new Date(dateInput)
  if (isNaN(date.getTime())) {
    return ''
  }
  const now = new Date()

  const seconds = differenceInSeconds(now, date)
  const minutes = differenceInMinutes(now, date)
  const hours = Math.floor(seconds / 3600)
  const today = isSameDay(now, date)

  if (seconds < 60) {
    return `${seconds} ${seconds > 1 ? 'secs' : 'sec'} ago`
  }
  if (minutes < 60) {
    return `${minutes} ${minutes > 1 ? 'mins' : 'min'} ago`
  }
  if (today) {
    return `${hours} ${hours > 1 ? 'hrs' : 'hr'} ago`
  }

  return format(date, 'dd MMM yy')
}

export function isYesterdayOrBefore(date: Date) {
  return isBefore(date, startOfDay(new Date()))
}

export function isSameDate(
  date1: string,
  date2: string,
  precision: 'day' | 'month' | 'year'
) {
  const date1Parsed = parseISO(date1)
  const date2Parsed = parseISO(date2)

  switch (precision) {
    case 'day':
      return isSameDay(date1Parsed, date2Parsed)
    case 'month':
      return isSameMonth(date1Parsed, date2Parsed)
    case 'year':
      return isSameYear(date1Parsed, date2Parsed)
  }
}
